import React from "react";
import { Link } from "react-router-dom";

const TermofUse = () => {
  return (
    <>
      <section className="section pricing__v2 cu_mtpd" id="pricing">
        <div className="container">
          <div className="row mb-5">
            <div className="col-md-5 mx-auto text-center">
              <span
                className="subtitle text-uppercase mb-3"
                data-aos="fade-up"
                data-aos-delay={0}
              >
                Terms
              </span>
              <h2 className="mb-3 text-[32px]" data-aos="fade-up" data-aos-delay={100}>
                Terms & Conditions
              </h2>
              <p data-aos="fade-up" data-aos-delay={200}>
                Well-Defined Terms & Conditions for Trust and Transparency
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 mb-4 mb-md-0" data-aos="fade-up" data-aos-delay={300}>
              <p className="mb-[10px]">
                <strong>1. Definitions</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	<strong>“You”</strong> refers to the individual or entity
                  accessing or using the Website or Service.
                </p>
                <p className="mb-[10px]">
                  •	<strong>“Content”</strong> refers to any information, data,
                  text, software, code, or other materials.
                </p>
                <p className="mb-[10px]">
                  •	<strong>“User”</strong> refers to any individual or entity who
                  accesses or uses the Website or Service.
                </p>
                <p className="mb-[10px]">
                  •	<strong>“Service Provider”</strong> refers to the independent, third-party medical professionals, doctors, and labs empanelled to fulfil requests.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>2. Nature of Service & Intermediary Status</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                    •	<strong>Technology Platform:</strong> Vedana Care provides a SaaS-based health-tech infrastructure.
                  </p>
                  <p className="mb-[10px]">
                    •	<strong>Aggregator Status:</strong> Vedana Care acts strictly as an Intermediary. We do not provide medical advice or treatment directly. The contract for medical service is strictly between the User and the Service Provider.
                  </p>
              </div>
              <p className="mb-[10px]">
                <strong>3. Use of the Website and Service</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	You may only use the Service for lawful purposes.
                </p>
                <p className="mb-[10px]">
                  •	You agree not to damage or impair the Service, interfere with other users, gain unauthorized access, or upload objectionable/unlawful content.
                </p>
                <p className="mb-[10px]">
                  •	You agree not to violate any applicable laws or regulations.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>4. User Content</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	You are solely responsible for any content you upload.
                </p>
                <p className="mb-[10px]">
                  •	You grant Vedana Care a royalty-free license to use and distribute your content in connection with the Service.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>5. Intellectual Property</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	The Website and Service are protected by copyright and trademark laws.
                </p>
                <p className="mb-[10px]">
                  •	You agree not to remove or alter proprietary notices.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>6. Disclaimers</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	THE SERVICE IS PROVIDED “AS IS” WITHOUT WARRANTIES OF ANY KIND.
                </p>
                <p className="mb-[10px]">
                  •	WE DISCLAIM ALL WARRANTIES OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
                </p>
                <p className="mb-[10px]">
                  •	<strong>MEDICAL DISCLAIMER: </strong>Vedana Care IS NOT RESPONSIBLE FOR CLINICAL OUTCOMES OR MEDICAL NEGLIGENCE BY THIRD-PARTY PROVIDERS.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>7. Telemedicine Consent & Compliance</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	By using Tele-Consultation, you provide voluntary consent to remote care.
                </p>
                <p className="mb-[10px]">
                  •	Per Indian Telemedicine Practice Guidelines 2020, you must provide valid ID and accurate age before the session begins.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>8. Pandemic & Force Majeure Exclusion</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	Vedana Care is not liable for failures beyond its control.
                </p>
                <p className="mb-[10px]">
                  •	<strong>Pandemic Clause:</strong>Plan benefits are <strong>not applicable or guaranteed</strong> during declared pandemics (e.g., COVID-19 or equivalent), epidemics, or natural disasters. Decision-making regarding service fulfilment during such events rests solely with Vedana Care.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>9. Limitation of Liability & Claim Cap</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	Vedana Care SHALL NOT BE LIABLE FOR INDIRECT OR CONSEQUENTIAL DAMAGES.
                </p>
                <p className="mb-[10px]">
                  •	The Company’s total liability for any claim shall not exceed the Plan Price paid by the User.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>10. Age Eligibility & Plan Limits</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	<strong>Group Insurance/Accident Rider:</strong> Limited to the primary holder aged 18-65 years under relevant plan(s) only.
                </p>
                <p className="mb-[10px]">
                  •	<strong>OPD Wellness Benefits:</strong> Available for members aged 0-85 years.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>11. Term and Termination</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	Terms remain in effect until terminated by you or Vedana Care.
                </p>
                <p className="mb-[10px]">
                  •	We may terminate at any time upon written notice.
                </p>
                <p className="mb-[10px]">
                  •	You may terminate by discontinuing use of the Service.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>12. Governing Law & Jurisdiction </strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	These Terms are governed by the laws of India.
                </p>
                <p className="mb-[10px]">
                  •	All disputes are subject to the exclusive jurisdiction of the courts in Varanasi
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>13. Entire Agreement, Severability, & Waiver</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	These Terms constitute the entire agreement.
                </p>
                <p className="mb-[10px]">
                  •	If any provision is held invalid, the remaining provisions remain in effect.
                </p>
                <p className="mb-[10px]">
                  •	No waiver of a provision shall be deemed a continuing waiver.
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>14. Update to Terms</strong>
              </p>
              <div className="pl-[20px]">
                <p className="mb-[10px]">
                  •	Vedana Care may update Terms at any time by posting on the Website.
                </p>
                <p className="mb-[10px]">
                  •	Continued use constitutes acceptance of amended Terms.
                </p>
                <p className="mb-[10px]">
                  •	If you have any questions about these terms, please contact us at support@vedanacare.com
                </p>
              </div>
              <p className="mb-[10px]">
                <strong>15. Grievance Redressal</strong>
              </p>
              <p className="mb-[10px]">
                •	In compliance with the Information Technology Act and DPDP Act, for any grievances, please contact our Grievance Officer:
              </p>
              <ul className="mb-[10px] pl-[20px]">
                <li className="mb-[10px]">
                  •	<strong>Email: </strong> support@vedanacare.com
                </li>
                <li className="mb-[10px]">
                  •	<strong>Acknowledgment: </strong> Within 72 hours of working days.
                </li>
                <li className="mb-[10px]">
                  •	<strong>Resolution: </strong> Estimated Within 45-60 days.
                </li>
              </ul>
              <p className="mb-[10px]">
                <strong>16. Disclaimers</strong>
              </p>
              <ul className="mb-[10px] pl-[20px]">
                <li className="mb-[10px]">
                  •	Valid ID proof is mandatory for all consultations
                </li>
                <li className="mb-[10px]">
                  •	Processing fee will be deducted for any plan cancellations
                </li>
                <li className="mb-[10px]">
                  •	Medicine bill – 20% discount by Vedana Care app. Home Delivery for minimum order worth amount: ₹425/-
                </li>
                <li className="mb-[10px]">
                  •	Vedana Care will be responsible only for our own prescribed centres / shops for lab, medical store or health check up.
                </li>
                <li className="mb-[10px]">
                  •	For my choice (in person visit) - Doctor's prescription, Reports, reports bill and Medicine bills to be uploaded at site where applicable.
                </li>
                <li className="mb-[10px]">
                  •	"For any rider based plan refund, surrender charges will be applicable."
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>

  );
};

export default TermofUse;
